export default __webpack_public_path__ + "static/media/swap.bdd13cca.png";